// @flow
import {createAction} from 'redux-actions';
import {getMessagesByLocaleAndAddLocaleData} from '../../i18n/I18nHelper';
import type {LanguageKey} from '../../config/LanguageConfig';

export const changeLanguageAction = createAction('CHANGE_LANGUAGE');

export const changeLanguage = (language: LanguageKey) => {
   return changeLanguageAction({
      data: {language},
      promise: getMessagesByLocaleAndAddLocaleData(language),
   });
};
